export default __webpack_public_path__ + "static/media/caera01.84181146.mp4";